const breakpoints = {
    small: 0,
    medium: 610,
    large: 950
}

export const small = (css) => {
    return `
        @media screen and (max-width: ${breakpoints.medium}px) {
            ${css}
        }
    `
}

export const medium = (css) => {
    return `
        @media screen and (min-width: ${breakpoints.medium}px) and (max-width: ${
        breakpoints.large - 1
    }px) {
            ${css}
        }
    `
}

export const large = (css) => {
    return `
        @media screen and (min-width: ${breakpoints.large}px) {
            ${css}
        }
    `
}
